var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":_vm.isAdd ? '新建人员' : '修改人员',"maskClosable":false,"width":640,"visible":_vm.visible,"confirmLoading":_vm.confirmLoading,"cancelText":'取消',"okText":'确定'},on:{"ok":_vm.handleSubmit,"cancel":_vm.handleCancel}},[_c('a-form',{attrs:{"layout":"horizontal","form":_vm.form}},[_c('a-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAdd),expression:"isAdd"}],attrs:{"label":"角色","labelCol":{ lg: { span: 7 } },"wrapperCol":{ lg: { span: 13 } }}},[_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'roleId',
          { rules: [{ required: true, message: '请选择角色' }] },
        ]),expression:"[\n          'roleId',\n          { rules: [{ required: true, message: '请选择角色' }] },\n        ]"}],staticClass:"form-cell",attrs:{"placeholder":"请选择"}},_vm._l((_vm.codeList),function(item,index){return _c('a-select-option',{key:index,attrs:{"value":item.id}},[_vm._v(_vm._s(item.roleName))])}),1)],1),_c('a-form-item',{attrs:{"label":"用户名","labelCol":{ lg: { span: 7 } },"wrapperCol":{ lg: { span: 13 } }}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'username',
          {
            rules: [
              {
                required: true,

                validator: _vm.usernameRules,
              },
            ],

            validateTrigger: 'change',
          },
        ]),expression:"[\n          'username',\n          {\n            rules: [\n              {\n                required: true,\n\n                validator: usernameRules,\n              },\n            ],\n\n            validateTrigger: 'change',\n          },\n        ]"}],attrs:{"type":"text","placeholder":"请输入"}})],1),(_vm.isAdd)?_c('a-form-item',{attrs:{"label":"密码","labelCol":{ lg: { span: 7 } },"wrapperCol":{ lg: { span: 13 } }}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'password',
          {
            rules: [
              {
                required: true,
                pattern: /^\S{6,15}$/,
                message: '请输入长度为6~15位的密码',
              },
            ],
            validateTrigger: 'change',
          },
        ]),expression:"[\n          'password',\n          {\n            rules: [\n              {\n                required: true,\n                pattern: /^\\S{6,15}$/,\n                message: '请输入长度为6~15位的密码',\n              },\n            ],\n            validateTrigger: 'change',\n          },\n        ]"}],attrs:{"type":"text","placeholder":"请输入"}})],1):_vm._e(),_c('a-form-item',{attrs:{"label":"姓名","labelCol":{ lg: { span: 7 } },"wrapperCol":{ lg: { span: 13 } }}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'nickname',
          {
            rules: [
              {
                required: true,
                pattern: /^.{2,45}$/,
                message: '请输入长度为2~45位的真实姓名',
              },
            ],
            validateTrigger: 'change',
          },
        ]),expression:"[\n          'nickname',\n          {\n            rules: [\n              {\n                required: true,\n                pattern: /^.{2,45}$/,\n                message: '请输入长度为2~45位的真实姓名',\n              },\n            ],\n            validateTrigger: 'change',\n          },\n        ]"}],attrs:{"type":"text","placeholder":"请输入","maxLength":45}})],1),_c('a-form-item',{attrs:{"label":"手机号","labelCol":{ lg: { span: 7 } },"wrapperCol":{ lg: { span: 13 } }}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'mobile',
          {
            rules: [
              { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号' },
            ],
            validateTrigger: 'change',
          },
        ]),expression:"[\n          'mobile',\n          {\n            rules: [\n              { pattern: /^1[3456789]\\d{9}$/, message: '请输入正确的手机号' },\n            ],\n            validateTrigger: 'change',\n          },\n        ]"}],attrs:{"type":"text","placeholder":"请输入"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }